
class Header {
    domElement;
    lastScrollTop = 0;
    isHidden = false;

    constructor(headerDomElement) {
        if (!headerDomElement) {
            return;
        }
        this.domElement = headerDomElement;
        this.init();
    }

    init = () => {
        this.handleScroll();
    };

    handleScroll = () => {
        let ticking = false;

        const onScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    const scrollThreshold = 50; // Минимальная прокрутка для активации
                    
                    // Определяем направление скролла
                    const scrollingDown = scrollTop > this.lastScrollTop;
                    const scrollingUp = scrollTop < this.lastScrollTop;
                    
                    // Скрываем хедер при скролле вниз (если прокрутили больше порога)
                    if (scrollingDown && scrollTop > scrollThreshold && !this.isHidden) {
                        this.isHidden = true;
                        this.domElement.classList.add('header--scrolling');
                    }
                    // Показываем хедер при скролле вверх
                    else if (scrollingUp && this.isHidden) {
                        this.isHidden = false;
                        this.domElement.classList.remove('header--scrolling');
                    }
                    // Показываем хедер, если вернулись в начало страницы
                    else if (scrollTop <= scrollThreshold && this.isHidden) {
                        this.isHidden = false;
                        this.domElement.classList.remove('header--scrolling');
                    }
                    
                    this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
                    ticking = false;
                });
                
                ticking = true;
            }
        };

        window.addEventListener('scroll', onScroll, { passive: true });
    };
}

export { Header };
